import {
  Box,
  Card,
  Checkbox,
  Dialog,
  FormControl,
  InputLabel,
  MenuItem,
  Chip,
  Button as MUIButton,
  Select,
  Tooltip,
  Typography,
} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import dayjs from 'dayjs';
import { ReactElement, useState } from 'react';
import {
  BulkDeleteButton,
  CreateButton,
  Datagrid,
  EditButton,
  Filter,
  FunctionField,
  List,
  TextField,
  NumberField,
  TopToolbar,
  useListController,
  useTranslate,
  DeleteButton,
  SelectField,
  TextInput,
  SelectInput,
} from 'react-admin';
import { CustomBreadcrumbs } from '../../../../components/custom-breadcrumbs';
import { DashboardContent } from '../../../../layouts/dashboard';
import { Resources } from '../resource';
import { PermissionGuard } from 'src/routes/components/permission-guard';
import ErrorPage403 from 'src/pages/error/403';
import { PermissionButton } from 'src/routes/components/permission-button';
import EditUnlimitedAgents from './Edit';
import CreateUnlimitedAgents from './Create';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

const ListFilter = (props: any) => {
  return <Filter {...(props || {})}></Filter>;
};

const UnlimitedAgentsList = () => {
  const [popup, setPopup] = useState<ReactElement>();
  const [editingId, setEditingId] = useState<string | null>(null);
  const translate = useTranslate();

  return (
    <DashboardContent>
      <PermissionGuard resource="unlimited-agents" action="read" fallback={<ErrorPage403 />}>
        <CustomBreadcrumbs
          heading={translate('resource.unlimitedAgents')}
          links={[
            {
              name: translate('resource.unlimitedAgents'),
              href: `/${Resources.unlimitedAgents}`,
            },
            { name: translate('resource.list') },
          ]}
          action={
            <PermissionGuard resource="unlimited-agents" action="create" fallback={<></>}>
              <CreateButton
                variant="contained"
                size="medium"
                onClick={(e) => {
                  e.preventDefault();
                  setPopup(<CreateUnlimitedAgents onClose={() => setPopup(undefined)} />);
                }}
              />
            </PermissionGuard>
          }
        />

        <Card sx={{ mt: 3, pb: 2 }}>
          <List actions={false} empty={false} perPage={10} exporter={false}>
            <Box sx={{ overflowX: 'auto' }}>
              <Datagrid
                rowClick={false}
                bulkActionButtons={
                  <PermissionButton resource="unlimited-agents" action="delete">
                    <BulkDeleteButton />
                  </PermissionButton>
                }
                sx={{
                  '& .RaDatagrid-table': {
                    tableLayout: 'fixed',
                    minWidth: 1600,
                    width: '100%',
                  },
                  '& .RaDatagrid-thead th, & .RaDatagrid-tbody td': {
                    whiteSpace: 'nowrap',
                    padding: '8px 12px',
                    verticalAlign: 'middle',
                  },
                  '& .RaDatagrid-thead th:nth-of-type(1), & .RaDatagrid-tbody td:nth-of-type(1)': {
                    width: 52,
                    minWidth: 52,
                  },
                  /* userId */
                  '& .RaDatagrid-thead th:nth-of-type(2), & .RaDatagrid-tbody td:nth-of-type(2)': {
                    width: 360,
                    minWidth: 360,
                  },
                  /* commissionRateN */
                  '& .RaDatagrid-thead th:nth-of-type(3), & .RaDatagrid-tbody td:nth-of-type(3)': {
                    width: 180,
                    minWidth: 180,
                  },
                  /* finalCommissionAmountUsd */
                  '& .RaDatagrid-thead th:nth-of-type(4), & .RaDatagrid-tbody td:nth-of-type(4)': {
                    width: 240,
                    minWidth: 240,
                  },
                  /* contractNetFeeUsd */
                  '& .RaDatagrid-thead th:nth-of-type(5), & .RaDatagrid-tbody td:nth-of-type(5)': {
                    width: 240,
                    minWidth: 240,
                  },
                  /* contractTotalFeeUsd */
                  '& .RaDatagrid-thead th:nth-of-type(6), & .RaDatagrid-tbody td:nth-of-type(6)': {
                    width: 240,
                    minWidth: 240,
                  },
                  '& .RaDatagrid-thead th:nth-of-type(7), & .RaDatagrid-tbody td:nth-of-type(7)': {
                    width: 220,
                    minWidth: 220,
                  },
                  '& .RaDatagrid-thead th:nth-of-type(8), & .RaDatagrid-tbody td:nth-of-type(8)': {
                    width: 220,
                    minWidth: 220,
                  },
                  '& .RaDatagrid-thead th:nth-of-type(9), & .RaDatagrid-tbody td:nth-of-type(9)': {
                    width: 220,
                    minWidth: 220,
                  },
                  '& .RaDatagrid-thead th:nth-of-type(10), & .RaDatagrid-tbody td:nth-of-type(10)':
                    {
                      width: 160,
                      minWidth: 160,
                    },
                  '& .RaDatagrid-thead th:nth-of-type(11), & .RaDatagrid-tbody td:nth-of-type(11)':
                    {
                      width: 260,
                      minWidth: 260,
                    },
                  '& .RaDatagrid-thead th:nth-of-type(12), & .RaDatagrid-tbody td:nth-of-type(12)':
                    {
                      width: 260,
                      minWidth: 260,
                    },
                  '& .RaDatagrid-thead th:nth-of-type(13), & .RaDatagrid-tbody td:nth-of-type(13)':
                    {
                      width: 260,
                      minWidth: 260,
                    },
                  '& .RaDatagrid-thead th:nth-of-type(14), & .RaDatagrid-tbody td:nth-of-type(14)':
                    {
                      width: 120,
                      minWidth: 120,
                    },
                  '& .RaDatagrid-thead th:nth-of-type(15), & .RaDatagrid-tbody td:nth-of-type(15)':
                    {
                      width: 160,
                      minWidth: 160,
                    },
                  '.RaBulkActionsToolbar-toolbar': {
                    position: 'relative !important',
                    transform: 'none !important',
                  },
                }}
              >
                <TextField source="userId" label="module.unlimitedAgents.userId" sortable={false} />
                <NumberField
                  source="commissionRateN"
                  label="module.unlimitedAgents.commissionRateN"
                  sortable={false}
                />
                <NumberField
                  source="finalCommissionAmountUsd"
                  label="module.unlimitedAgents.finalCommissionAmountUsd"
                  sortable={false}
                  options={{ minimumFractionDigits: 3, maximumFractionDigits: 6 }}
                />
                <NumberField
                  source="contractNetFeeUsd"
                  label="module.unlimitedAgents.contractNetFeeUsd"
                  sortable={false}
                  options={{ minimumFractionDigits: 3, maximumFractionDigits: 6 }}
                  headerClassName="col-contractNetFeeUsd"
                  cellClassName="col-contractNetFeeUsd"
                />
                <NumberField
                  source="contractTotalFeeUsd"
                  label="module.unlimitedAgents.contractTotalFeeUsd"
                  sortable={false}
                  options={{ minimumFractionDigits: 3, maximumFractionDigits: 6 }}
                />

                <NumberField
                  source="memeVolumeUsd"
                  label="module.unlimitedAgents.memeVolumeUsd"
                  sortable={false}
                  options={{ minimumFractionDigits: 3, maximumFractionDigits: 6 }}
                />
                <NumberField
                  source="memeNetFeeUsd"
                  label="module.unlimitedAgents.memeNetFeeUsd"
                  sortable={false}
                  options={{ minimumFractionDigits: 3, maximumFractionDigits: 6 }}
                />
                <NumberField
                  source="memePaidCommissionUsd"
                  label="module.unlimitedAgents.memePaidCommissionUsd"
                  sortable={false}
                  options={{ minimumFractionDigits: 3, maximumFractionDigits: 6 }}
                />
                <NumberField
                  source="totalNetFeeUsd"
                  label="module.unlimitedAgents.totalNetFeeUsd"
                  sortable={false}
                  options={{ minimumFractionDigits: 3, maximumFractionDigits: 6 }}
                />
                <NumberField
                  source="totalStandardCommissionPaidUsd"
                  label="module.unlimitedAgents.totalStandardCommissionPaidUsd"
                  sortable={false}
                  options={{ minimumFractionDigits: 3, maximumFractionDigits: 6 }}
                />
                {/* <FunctionField
                  label="module.unlimitedAgents.createdAt"
                  source="createdAt"
                  sortable={false}
                  render={(r: any) =>
                    r?.createdAt ? dayjs(r.createdAt).format('YYYY-MM-ss HH:mm:ss') : '-'
                  }
                /> */}
                <TextField
                  source="createdAt"
                  label="module.unlimitedAgents.createdAt"
                  sortable={false}
                />
                <TextField
                  source="updatedAt"
                  label="module.unlimitedAgents.updatedAt"
                  sortable={false}
                />
                <FunctionField
                  label="module.unlimitedAgents.isActive"
                  render={(record) => (
                    <Chip
                      label={record.status === 'ACTIVE' ? 'True' : 'False'}
                      color={record.status === 'ACTIVE' ? 'success' : 'error'}
                      size="small"
                    />
                  )}
                  sortable={false}
                />
                <FunctionField
                  render={(record: any) => (
                    <Stack direction="row" spacing={2}>
                      <PermissionGuard resource="unlimited-agents" action="update" fallback={<></>}>
                        <EditButton
                          onClick={(e) => {
                            e.preventDefault();
                            setPopup(
                              <EditUnlimitedAgents
                                id={record.id}
                                open
                                onClose={() => setPopup(undefined)}
                              />
                            );
                          }}
                        />
                      </PermissionGuard>
                      <PermissionGuard resource="unlimited-agents" action="delete" fallback={<></>}>
                        <DeleteButton mutationMode="pessimistic" />
                      </PermissionGuard>
                    </Stack>
                  )}
                />
              </Datagrid>
            </Box>
          </List>
        </Card>
        <Dialog open={Boolean(popup)} onClose={() => setPopup(undefined)} maxWidth="md" fullWidth>
          {popup}
        </Dialog>
      </PermissionGuard>
      {/* {editingId && <EditUnlimitedAgents id={editingId} onClose={() => setEditingId(null)} />} */}
    </DashboardContent>
  );
};

export default UnlimitedAgentsList;
